export default {
  inquiries: [],
  inquiry: {},
  inquiryItems : [],
  baseInquiries : [],
  baseInquiryInquiries : [],
};
